export default "__VITE_ASSET__B1X1iMxh__"